export var GLOBAL_SRC = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
